import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { ConvertInput, Quotation, QuotationInput, QuotationStatus } from '../types/quotationTypes';

export const quotationService = {
  ...crudService<Quotation, QuotationInput>('/quotations'),
  setStatus: (id: string, status: QuotationStatus) => api.post<ApiResponse<Quotation>>(`/quotations/${id}/status`, { status }).then((r) => r.data),
  duplicate: (id: string) => api.post<ApiResponse<Quotation>>(`/quotations/${id}/duplicate`).then((r) => r.data),
  /** Creates a service job; returns { service, quotation } */
  convert: (id: string, body: ConvertInput) => api.post(`/quotations/${id}/convert`, body).then((r) => r.data),
  openPdf: (id: string) => api.openPdf(`/quotations/${id}/pdf`),
  /** Material list for buying (no prices shown to the customer) */
  openMaterialListPdf: (id: string) => api.openPdf(`/quotations/${id}/material-list-pdf`),
};
